import { useState, useEffect, useCallback } from "react";
import { Camera } from "../../components";
import fileUtils from "../../utils/fileUtils";
import imageCompression from "browser-image-compression";
import { getDic } from "../../assets/i18n/dictionary";

export default function TakePhoto(props) {
  const {
    setStep,
    dimensions,
    configOptions,
    lightenHex,
    tryCaptureFace,
    openMessageFileError,
  } = props;
  const [cameraControl, setCameraControl] = useState({
    hasPermission: false,
    cameraAvailable: false,
    errorMessage: "",
    isOpen: false,
  });

  const checkCamera = useCallback(async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasVideoInput = devices.some((d) => d.kind === "videoinput");

      if (!hasVideoInput) {
        setCameraControl({
          ...cameraControl,
          errorMessage: getDic("nenhuma-camera-detectada"),
          cameraAvailable: false,
          isOpen: true,
        });
        return;
      }

      await navigator.mediaDevices.getUserMedia({ video: true });
      setCameraControl({
        ...cameraControl,
        cameraAvailable: true,
        hasPermission: true,
        isOpen: true,
      });
    } catch (err) {
      console.error("Erro ao acessar câmera:", err);
      setCameraControl({
        ...cameraControl,
        errorMessage: getDic("erro-acesso-camera"),
        hasPermission: false,
        isOpen: true,
      });
    }
  }, []);

  useEffect(() => {
    checkCamera();
  }, []);

  if (!cameraControl.isOpen) {
    return null;
  }
  return (
    <>
      {cameraControl.cameraAvailable && cameraControl.hasPermission ? (
        <CapturePhoto
          cameraControl={cameraControl}
          configOptions={configOptions}
          lightenHex={lightenHex}
          dimensions={dimensions}
          tryCaptureFace={tryCaptureFace}
        />
      ) : (
        <SelectPhoto
          configOptions={configOptions}
          lightenHex={lightenHex}
          dimensions={dimensions}
          tryCaptureFace={tryCaptureFace}
          openMessageFileError={openMessageFileError}
        />
      )}
    </>
  );
}

function SelectPhoto(props) {
  const { dimensions, configOptions, lightenHex, openMessageFileError, tryCaptureFace } =
    props;
  const [file, setFile] = useState(null);

  const trySetImage = useCallback((e) => {
    if (!e.target.files || !e.target.files[0]) {
      openMessageFileError();
      return;
    }
    setFile(e.target);
  }, [openMessageFileError]);

  const getBase64FromImage = useCallback(async () => {
    if (!file) return;
    const compressed = await imageCompression(file.files[0], {
      maxSizeMB: 2,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    });
    const base64 = await fileUtils.convertFileToBase64(compressed);
    tryCaptureFace(base64);
  }, [file, tryCaptureFace]);

  return (
    <>
      <div className="div-card">
        <h4 style={{
          background: lightenHex(configOptions.backgroundColor, 20),
          color: configOptions.textColor
        }}>
          {getDic("selecione-uma-imagem")}
        </h4>
        <input
          type="file"
          accept="image/png, image/jpeg"
          className="file-selectPhoto"
          style={{
            background: configOptions.buttonBackgroundColor,
            color: configOptions.buttonTextColor,
          }}
          onChange={trySetImage}
        />
        <button
          className="file-selectPhoto"
          style={{
            border: "none",
            marginTop: 20,
            background: configOptions.buttonBackgroundColor,
            color: configOptions.buttonTextColor,
          }}
          onClick={getBase64FromImage}
        >
          {getDic("enviar-imagem")}
        </button>
      </div>
    </>
  );
}

function CapturePhoto(props) {
  const { cameraControl, dimensions, configOptions, lightenHex, tryCaptureFace } = props;
  const width = Math.min(640, dimensions.width - 20);
  const height = Math.min(480, Math.max(200, dimensions.height - 160));
  return (
    <div style={{ marginTop: 20 }}>
      {cameraControl.cameraAvailable && cameraControl.hasPermission && (
        <Camera
          configOptions={configOptions}
          width={width}
          height={height}
          onPhoto={(i) => tryCaptureFace(i)}
          v3={true}
        />
      )}
    </div>
  );
}
